/**
 * NaverMapView — 네이버 지도 프레젠테이션 컴포넌트
 */

import { useRef } from 'react'
import { useNaverMap } from '../../../hooks/useNaverMap.js'
import common from './common.module.css'

interface NaverMapViewProps {
  lat: number
  lng: number
  interactive?: boolean
  label?: string
}

export function NaverMapView({ lat, lng, interactive = true, label }: NaverMapViewProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const { isLoaded, error } = useNaverMap(containerRef, { lat, lng, interactive, label })

  if (error) return null

  return (
    <div ref={containerRef} className={common.mapContainer}>
      {!isLoaded && (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <span className={common.placeholderText}>지도 로딩중...</span>
        </div>
      )}
    </div>
  )
}
